module.exports = __webpack_public_path__ + "img/caas4m.d844b7d2.webp";